var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorConfusion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.893 95.9999L73.2263 21.3332C72.296 19.6917 70.9468 18.3262 69.3166 17.3763C67.6863 16.4263 65.8332 15.9258 63.9463 15.9258C62.0594 15.9258 60.2063 16.4263 58.576 17.3763C56.9457 18.3262 55.5966 19.6917 54.6663 21.3332L11.9996 95.9999C11.0593 97.6285 10.5662 99.4767 10.5703 101.357C10.5745 103.238 11.0758 105.084 12.0233 106.708C12.9709 108.333 14.3311 109.678 15.966 110.607C17.6009 111.536 19.4525 112.017 21.333 112H106.666C108.538 111.998 110.376 111.504 111.996 110.567C113.616 109.63 114.961 108.283 115.896 106.662C116.831 105.041 117.323 103.202 117.322 101.33C117.322 99.459 116.829 97.6206 115.893 95.9999Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48V69.3333",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 90.667H64.0533",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorConfusion);
export default __webpack_public_path__ + "static/media/vendor-confusion.4166bb2510ec399fdb28a9c5c4a5cd7f.svg";
export { ForwardRef as ReactComponent };